module.exports = __webpack_public_path__ + "img/csvFile.307f88ce.svg";